export const leftMargin = 100;
export const bottomMargin = 100;
export const topMargin = 50;
export const rightMargin = 50;

export const textColor = 'white';
